import { select } from '@ptl/angular-redux-store';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormBroadcast, FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { Observable, Subscription } from 'rxjs';
import { SpecialEnrollmentCircumstance } from 'src/app/angular-elements/shared/interfaces/special-enrollment-circumstances.interface';
import { FamilyFormService } from '../../family-form/services/family-form.service';
import { GetOpenEnrollmentRule } from '../../family-form/types/qualifying-life-event.response.interface';

interface ComponentFormControls {
  lifeEvent: AbstractControl;
}

interface EventReason {
  label: string;
  value: string;
}
@FormComponentLookup('special-enrollment-event-reason')
@Component({
  selector: 'app-special-enrollment-event-reason',
  templateUrl: './special-enrollment-event-reason.component.html',
  styleUrls: ['./special-enrollment-event-reason.component.scss'],
  standalone: false
})
export class SpecialEnrollmentEventReasonComponent extends FormEntryComponentClass implements OnInit, AfterViewInit, OnDestroy {

  @select(['payloadStates', 'special-enrollment-circumstance', 'lifeEvent', 'lifeEventId']) lifeEventId$: Observable<string>
  eventReasons: EventReason[] = [];
  currentLifeEventId: string;
  private lifeEventSubscription: Subscription;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.initializeFromState();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.setupEventListeners();
  }

  private initializeFromState() {
      const payloadStates = this.reducerUtilityService.getPayloadStates();
      const specialEnrollmentState: SpecialEnrollmentCircumstance = payloadStates['special-enrollment-circumstance'];

      this.currentLifeEventId = specialEnrollmentState.lifeEvent.lifeEventId;
      
      this.loadReasons();
  }

  private setupEventListeners() {
    this.lifeEventSubscription = this.lifeEventId$.subscribe(lifeEventId => {
      this.currentLifeEventId = lifeEventId;
      
      this.loadReasons();

      this.form?.get(this.entry?.formControlAttributes.formControlName)?.updateValueAndValidity();
    })
  }

  private handleLifeEventChange(newLifeEventId: string) {
    if(newLifeEventId !== this.currentLifeEventId) {
      this.currentLifeEventId = newLifeEventId;
      this.loadReasons();
      this.resetReasonControl();
    }
  }

  private loadReasons() {
    const reasonsMapping = this.entry?.custom?.reasonsMapping || [];
    const matchedReason = reasonsMapping.find((m: { lifeEventId: string; }) => m.lifeEventId === this.currentLifeEventId);
    this.eventReasons = matchedReason?.options || [];
  }

  private resetReasonControl() {
    const control = this.form?.get(this.entry.formControlAttributes.formControlName);
    control?.reset();
    control?.updateValueAndValidity();
  }

  compareWithFn = (a: EventReason, b: EventReason) => a?.value === b?.value;

  ngOnDestroy() {
    super.ngOnDestroy();
    this.lifeEventSubscription?.unsubscribe();
  }
}
